/* ═══════════════════════════════════════
   Ocean Savage — Search Overlay
   ═══════════════════════════════════════ */

(function () {
  var overlay, input, resultsEl, trendingHTML;
  var searchTimeout = null;

  function open() {
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 50);
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (input) input.value = '';
    if (resultsEl && trendingHTML) resultsEl.innerHTML = trendingHTML;
  }

  // Predictive search API returns price in dollars (not cents)
  function formatMoney(dollars) {
    var n = parseFloat(dollars);
    if (isNaN(n)) return '';
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function renderProducts(products, label) {
    if (!resultsEl) return;
    if (!products || !products.length) {
      resultsEl.innerHTML = '<p class="search-overlay__label">NO RESULTS</p>';
      return;
    }
    resultsEl.innerHTML =
      '<p class="search-overlay__label">' + label + '</p>' +
      '<div class="search-overlay__products">' +
      products.slice(0, 6).map(function (p) {
        var img = p.featured_image ? '<img src="' + p.featured_image.url + '&width=400" alt="' + (p.title || '') + '" loading="lazy">' : '';
        var price = p.price ? formatMoney(p.price) : '';
        return '<a href="' + p.url + '" class="search-overlay__product">' +
          '<div class="search-overlay__product-img">' + img + '</div>' +
          '<span class="search-overlay__product-name">' + (p.title || '').toUpperCase() + '</span>' +
          '<span class="search-overlay__product-price">' + price + '</span>' +
          '</a>';
      }).join('') +
      '</div>';
  }

  function doSearch(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderProducts(products, 'RESULTS FOR "' + q.toUpperCase() + '"');
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    overlay  = document.querySelector('[data-search-overlay]');
    input    = document.querySelector('[data-search-input]');
    resultsEl = document.querySelector('[data-search-results]');

    if (!overlay) return;

    // Capture initial trending HTML for resetting later
    trendingHTML = resultsEl ? resultsEl.innerHTML : '';

    // Open buttons (desktop + mobile)
    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });

    // Close
    var closeBtn = overlay.querySelector('[data-search-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    var backdrop = overlay.querySelector('[data-search-backdrop]');
    if (backdrop) backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    // Live search
    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(searchTimeout);
        if (q.length < 2) {
          if (resultsEl && trendingHTML) resultsEl.innerHTML = trendingHTML;
          return;
        }
        searchTimeout = setTimeout(function () { doSearch(q); }, 300);
      });
    }
  });
})();
